import React from 'react';
import classnames from 'classnames';
import { shape, object, bool, string } from 'prop-types';
import { Box } from '@fiverr-private/theme';
import { DIGITAL_MARKETING_CATEGORY_ID, PROGRAMMING_AND_TECH_CATEGORY_ID } from '../../../constants';
import { ConfigLevelProps, ConfigMenuItemProps } from '../../../types';
import { MENU_PANEL_TYPE } from '../../../utils';
import MenuItem from '../MenuItem';
import MenuItemToggler from '../../MenuItemToggler';
import DefaultPanel from './DefaultPanel';
import BucketPanel from './BucketPanel';

const MenuPanelTypes = {
    [MENU_PANEL_TYPE.DEFAULT]: DefaultPanel,
    [MENU_PANEL_TYPE.BUCKET]: BucketPanel,
    [MENU_PANEL_TYPE.BUCKETS_WITH_TITLE]: BucketPanel,
    [MENU_PANEL_TYPE.BUCKETS_WITHOUT_TITLE]: BucketPanel,
};

const TOP_LEVEL_DATA_CLASS = 'top';

const MenuPanel = ({ item, mode, config, eventTracker, shouldPreRender, shouldShowPostBriefCta = false }) => {
    const RenderedMenuPanel = MenuPanelTypes[item.menuType] || DefaultPanel;
    const categoryId = Number(item?.reportData?.categoryId);
    const showAgenciesBanner =
        categoryId === DIGITAL_MARKETING_CATEGORY_ID || categoryId === PROGRAMMING_AND_TECH_CATEGORY_ID;

    return (
        <MenuItemToggler>
            {(isOpen, preventCloseAction, handleClick, handleMouseLeave, handleMouseOver) => (
                <MenuItem
                    preventCloseAction={preventCloseAction}
                    className={classnames('target top-level', [item.menuType], {
                        open: isOpen && config.level_2,
                        shouldPreRender,
                    })}
                    showAgenciesBanner={showAgenciesBanner}
                    level={TOP_LEVEL_DATA_CLASS}
                    handleClick={handleClick}
                    handleMouseLeave={(e) => {
                        handleMouseLeave(e);
                    }}
                    handleMouseOver={(e) => {
                        handleMouseOver(e);
                    }}
                    item={item}
                    eventTracker={eventTracker}
                >
                    {isOpen || shouldPreRender ? (
                        <>
                            {shouldShowPostBriefCta && <Box height="8px" />}
                            <RenderedMenuPanel
                                mode={mode}
                                item={item}
                                config={config}
                                eventTracker={eventTracker}
                                shouldShowPostBriefCta={shouldShowPostBriefCta}
                            />
                        </>
                    ) : null}
                </MenuItem>
            )}
        </MenuItemToggler>
    );
};

MenuPanel.propTypes = {
    item: ConfigMenuItemProps,
    config: shape({
        level_2: ConfigLevelProps,
        level_3: ConfigLevelProps,
    }),
    eventTracker: object,
    shouldPreRender: bool,
    shouldShowPostBriefCta: bool,
    mode: string,
};

MenuPanel.defaultProps = {
    shouldPreRender: true,
};

export default MenuPanel;
